import React from 'react';
import { Button, Typography } from '@mui/material';
import StarOutlineRoundedIcon from '@mui/icons-material/StarOutlineRounded';
import { YouCard, PrimaryButton } from './YouPrimitives';
import { useEntitlement } from '../hooks/useEntitlement';

// compact : colonne etroite du maitre-detail, le libelle doit tenir sur une ligne,
// y compris avec le prix long que renvoie Google Play ("30,00 EUR").
const PurchaseCard = ({ onUnlock, onSignIn, compact = false }) => {
  const { priceLabel } = useEntitlement();

  return (
    <YouCard
      sx={{
        background:
          'linear-gradient(135deg, rgba(var(--accent-rgb), 0.16), rgba(var(--accent-rgb), 0.04)), #141416',
      }}
    >
      <Typography sx={{ fontSize: 17, fontWeight: 600, color: '#fff' }}>Free version</Typography>
      <Typography
        sx={{ fontSize: 13, fontWeight: 300, color: 'rgba(255,255,255,0.7)', mt: '6px', mb: '14px' }}
      >
        All keys, all scales, the core backings. No subscription.
      </Typography>
      <PrimaryButton
        onClick={onUnlock}
        startIcon={<StarOutlineRoundedIcon />}
        sx={compact ? { height: 40, fontSize: 13, px: 1.5 } : undefined}
      >
        {compact ? `Unlock · ${priceLabel}` : `Unlock upScale · ${priceLabel} once`}
      </PrimaryButton>
      {/* Invité seulement : qui a déjà un accès ailleurs le retrouve ici au
          lieu de payer une seconde fois. Même libellé que UnlockSheet. */}
      {onSignIn && (
        <Button
          fullWidth
          onClick={onSignIn}
          sx={{
            mt: '8px',
            height: compact ? 36 : 40,
            textTransform: 'none',
            fontSize: compact ? 13 : 14,
            fontWeight: 600,
            color: '#fff',
            borderRadius: '10px',
            '&:hover': { backgroundColor: 'rgba(255,255,255,0.06)' },
          }}
        >
          Already have access? Sign in
        </Button>
      )}
    </YouCard>
  );
};

export default PurchaseCard;
